export default __webpack_public_path__ + "static/media/lion500x555.28a28aa4.png";